

$(document).on('click', '.hamburger-button', function() {
  $(".hamburger-button").toggleClass('is-active');
  $(".nav-items-list").toggleClass('hamburger-is-selected')
});
